import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ImagesContainer, ImageFull, Image1, Image2, Image3, Image4,
} from './UseCasesImagesContainer.styles';
import Image11 from '../../assets/images/UseCases/image-1.png';
import Image22 from '../../assets/images/UseCases/image-2.png';
import Image33 from '../../assets/images/UseCases/image-3.png';
import Image44 from '../../assets/images/UseCases/image-4.png';
import unitImage from '../../assets/images/UseCases/unitImages2.png';

export const UseCasesImagesContainer = ({ useSeparates }) => {
  const { t } = useTranslation();

  return (
    <>
      {useSeparates ? (
        <ImagesContainer>
          <Image1 src={Image11} alt={t('Registro de nuevos clientes con Onboarding digital')} title={t('Registro de nuevos clientes con Onboarding digital')} />
          <Image2 src={Image22} alt={t('Escaneo facial para verificar la identidad de tus clientes')} title={t('Verificación de identidad con escaneo facial')} />
          <Image3 src={Image33} alt={t('Aprobación de crédito para tus clientes')} title={t('Preaprobación de crédito')} />
          <Image4 src={Image44} alt={t('Transacciones y pagos del cliente')} title={t('Portal de clientes Dynamicore')} />
        </ImagesContainer>
      ) : (
        <ImagesContainer>
          <ImageFull src={unitImage} alt={t('Registro de nuevos clientes con Onboarding digital')} />
        </ImagesContainer>
      )}
    </>
  );
};
